import { render, staticRenderFns } from "./PTopAboutTrustIndex.vue?vue&type=template&id=d9ec2d02&"
import script from "./PTopAboutTrustIndex.vue?vue&type=script&lang=js&"
export * from "./PTopAboutTrustIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports